export const googleMapStyle = {
  width: '100%',
  height: '100%',
  borderRadius: '8rem',
  maxHeight: '290rem',
};
